export default [
  {
    title: '设备SN',
    dataIndex: 'deviceSn',
    key: 'deviceSn'
  },
  {
    title: '是否到账',
    dataIndex: 'isWriteOff',
    key: 'isWriteOff',
    scopedSlots: { customRender: 'isWriteOff' },
  }
]
